import { singOut } from "../../store/slices/userSlice";
import store from "../../store/store";
import { connector } from "../../utils/common/connector";

// ---------------------------------------------
// SEND EMAIL
// ---------------------------------------------
export const sendEmailService = async (params) => {
  let reply;

  try {
    const response = await connector.post("mail", "sendEmail", params);

    reply = response ?? { sentEmail: false };
  } catch (error) {
    console.log(error);
    reply = { sentEmail: false };
  }

  return reply;
};

export const forgetPassword = async (email) => {
  const baseApi = process.env.REACT_APP_API_BASE;

  const options = {
    method: "POST", // specifying the HTTP method
    headers: {
      "Content-Type": "application/json", // specifying the Content-Type of the request body
    },
    body: JSON.stringify({
      email,
    }),
  };

  const response = await fetch(
    `${baseApi}forgetPassword/resetPassword`,
    options,
  ).then((response) => response.json());

  const json = await response;

  if (json?.token === false) {
    store.dispatch(singOut());
    return {
      error: true,
    };
  }

  return json;
};
